<template>
  <div>
    <Row>
      <Form ref="queryCarForm" :model="query" :label-width="70" label-position="right" inline class="index-query-form">
        <Input
          v-model="query.plateNo"
          placeholder="请输入车牌号"
          style="width:150px;margin-right: 10px;"
        />
        <Input
          v-model="query.personId"
          placeholder="请输入人员id"
          style="width:150px;margin-right: 10px;"
        />
       <!-- <Select v-model="search.vipState" class="tool-item" placeholder="请选择是否会员">
          <Option
            v-for="item in dict.sys_yes_no"
            :value="item.dictKey"
            :key="item.dictValue"
          >
            {{ item.dictValue }}
          </Option>
        </Select>
        <DatePicker
          v-model="search.vipBeginTime"
          type="datetime"
          placeholder="选择vip包期开始时间"
          @on-change="queruVipBeginTimeFormat"
        ></DatePicker>
        <DatePicker
          v-model="search.vipEndTime"
          type="datetime"
          placeholder="选择vip包期结束时间"
          @on-change="queruVipEndTimeFormat"
        ></DatePicker>-->
        <Form-item :label-width="0">
          <span @click="handleSearch" style="margin: 0 10px;"><Button
            type="primary">{{$t('searchText')}}</Button></span>
          <Button @click="resetSearchForm" type="default">{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openCarDrawer()" type="primary" style="margin-right: 10px;float:right">{{$t('newText')}}
        </Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1" style="width:100%;">
      <Table ref="carTable" :columns="columns" stripe border :data="page.data"
             @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle">
        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label"
                    :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.carTable.getSelection().length == 0"
                  :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' :
            '确 定' }}
          </Button>
        </div>
        <Page :current="page.current" :total="page.total" :page-size="page.size" @on-change="handlePageChange"
              show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="carDrawer" :title="this.$t('drawer.title')[carDrawer.type]" :visible.sync="carDrawer.visible"
               direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <car-form ref="carForm"/>
        <div class="right-drawer__footer" v-if="carDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="carDrawer.submiting">{{ carDrawer.submiting ? '提交中...' : '保 存' }}
          </Button>
          <Button @click="carDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
  import Vue from 'vue'

  import api from '@/api'
  import mixin from '@/libs/mixins/Index'

  import CarForm from '@/views/travel/car/components/Form.vue'

  Vue.component('car-form', CarForm)

  export default {
    dictParams: ['plate_color', 'plate_type', 'car_color', 'car_type', 'vip_status'],
    name: 'aip-travel-car-index',
    mixins: [mixin],
    data () {
      return {
        query: {
          personId:'',
          plateNo:''
        },
        page: {
          size: 10,
          current: 1,
          total: 0,
          sort: 'id_desc',
          loading: false,
          data: []
        },
        carDrawer: {
          action: 'add',
          visible: false,
          submiting: false
        },
        batchOperate: {
          action: '',
          submiting: false,
          options: [
            { value: 'handleBatchRemove', label: '批量删除' }
          ]
        }
      }
    },
    methods: {
      handleBatchOperate(){
        let records = this.$refs.carTable.getSelection()
        if (records.length == 0) {
          this.$Message.warning(this.$t('errorText'))
          return;
        }
        this[this.batchOperate.action](records)
      },
      handleSearch () {
        this.page.loading = true
        api.travel.Car.query(this.query, this.page)
          .then(data => {
            this.page = Object.assign(this.page, data)
            this.page.loading = false
          }).catch(error => this.page.loading = false)
      },
      openCarDrawer (car) {
        this.carDrawer.visible = true
        this.carDrawer.type = car ? car.type : 'add'
        this.$nextTick(() => {
          if (car) {
            this.$refs['carForm'].getCar(car.id, car.type)
          } else {
            this.$refs['carForm'].handleReset()
          }
        })
      },
      handleSubmit () {
        this.carDrawer.submiting = true
        this.$refs.carForm.handleSubmit(
          data => {
            this.carDrawer.submiting = false
            this.handleSearch()
            setTimeout(() => this.carDrawer.visible = false, 1000)
          },
          () => {
            this.carDrawer.submiting = false
          }
        )
      },
      deleteCar (id) {
        api.travel.Car.remove(id)
          .then(response => {
            this.$Message.success(this.$t('successText'))
            this.handleSearch()
          }).catch(error => console.log(error))
      },
      handleBatchRemove (rows) {
        this.batchOperate.submiting = true
        Promise.all(rows.map(item => api.travel.Car.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false
            this.handleSearch()
          }).catch(e => {
          this.batchOperate.submiting = false
          this.handleSearch()
        })
      }
    },
    computed: {
      columns () {
        return [
          { key: 'id', width: 60, fixed: 'left', type: 'selection' },

          { key: 'plateNo', align: 'left', minWidth: 120, fixed: 'left', title: this.$t('travel.car.plateNo.label') },
          { key: 'personId', align: 'left', minWidth: 120, title: this.$t('travel.car.personId.label') },
          {
            key: 'plateType',
            align: 'left',
            width: 120,
            filters: this.dict.plate_type,
            filterMultiple: false,
            title: this.$t('travel.car.plateType.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.plateType == t.dictKey).dictValue}</div>
            }
          },
          {
            key: 'plateColor',
            align: 'left',
            width: 80,
            filters: this.dict.plate_color,
            filterMultiple: false,
            title: this.$t('travel.car.plateColor.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.plateColor == t.dictKey).dictValue}</div>
            }
          },
          {
            key: 'vehicleType',
            align: 'left',
            width: 80,
            filters: this.dict.car_type,
            filterMultiple: false,
            title: this.$t('travel.car.vehicleType.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.vehicleType == t.dictKey).dictValue}</div>
            }
          },
          {
            key: 'vehicleColor',
            align: 'left',
            width: 80,
            filters: this.dict.car_color,
            filterMultiple: false,
            title: this.$t('travel.car.vehicleColor.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.vehicleColor == t.dictKey).dictValue}</div>
            }
          },
          {
            key: 'vipState',
            align: 'left',
            width: 80,
            filters: this.dict.vip_status,
            filterMultiple: false,
            title: this.$t('travel.car.vipState.label'),
            render: (h, params) => {
              return  <div>
                <i-switch value={
                  params.row.vipState?true:false
                } onOn-change={(v)=>{
                  v=v?1:0;
                  api.travel.Car.changeDefaultFlag(params.row.id,v).then(e=>{
                    if (e.code == 200) {
                      this.$Message.success(e.msg)
                    } else {
                      this.$Message.error(e.msg)
                    }
                  })}
                }>
                </i-switch>
              </div>
            }

          },
          { key: 'vipBeginTime', align: 'center', width: 170, title: this.$t('travel.car.vipBeginTime.label'), },
          { key: 'vipEndTime', align: 'center', width: 170, title: this.$t('travel.car.vipEndTime.label'), },
          { key: 'description', align: 'left', minWidth: 120, title: this.$t('travel.car.description.label') },
          {
            title: this.$t('operateText'),
            align: 'center',
            width: 140,
            fixed: 'right',
            key: 'handle',
            render: (h, params) => {
              return <div style="display: flex;justify-content: space-around;">
                <a href="javascript:void(0);"
                   onClick={() => this.openCarDrawer({ id: params.row.id, type: 'detail' })}>{this.$t('detailText')}</a>
                <a href="javascript:void(0);"
                   onClick={() => this.openCarDrawer({ id: params.row.id, type: 'edit' })}>{this.$t('editText')}</a>
                <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true}
                        onOn-ok={() => this.deleteCar(params.row.id)}>
                  <a href="javascript:void(0);">{this.$t('deleteText')}</a>
                </Poptip>
              </div>
            }
          }
        ]
      }
    }
  }
</script>
